<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<div class="wrapper">
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-black navbar-light">
    <ul class="navbar-nav">

      <li class="nav-item" (click)="toggleShow()">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <!-- <li>
        <a href="index3.html" class="brand-link" *ngIf="isShown==fals">
          <img src="assets/img/logo.webp" alt="Momentum India Logo" class="brand-image-nav " style="opacity: 1">   
        </a>
      </li> -->
    </ul>

    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="type!='superadmin'" (click)="getNotification()">
          <i class="far fa-comments"></i>
          <span class="badge badge-danger navbar-badge" *ngIf="showCount>0">{{ showCount>9?'9+':showCount }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right chatdropdown">
          <div class="noti" *ngIf="notifyList.length==0"> No Notification Yet </div>
          <div *ngIf="incident_id!=0 && incident_id!='' && incident_id!=null">
            <a [routerLink]="['incident-details-view', item.incident_id]" class="dropdown-item"
              *ngFor="let item of sortByLastModifiedAsend; let i = index" >
              <div class="media">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{ item.by_name}}
                    <!--<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>-->
                  </h3>
                  <p class="text-sm">{{ item.title}}</p>
                  <p class="text-sm text-muted time"><i class="far fa-clock mr-1"></i> {{ timePassed(item.created_at) }}
                  </p>
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </a>
          </div>
          <div *ngIf="permit_id!='' && permit_id!=null &&permit_id!=0">
            <a [routerLink]="['work-permit-details', item.permit_id]" class="dropdown-item"
              *ngFor="let item of notifyList; let i = index">
              <div class="media">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{ item.by_name}}
                    <!--<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>-->
                  </h3>
                  <p class="text-sm">{{ item.title}}</p>
                  <p class="text-sm text-muted time"><i class="far fa-clock mr-1"></i> {{ timePassed(item.created_at) }}
                  </p>
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </a>
          </div>
          <div *ngIf="accident_id!='' && accident_id!=null &&accident_id!=0">
            <a [routerLink]="['accident-details-view', item.accident_id]" class="dropdown-item"
              *ngFor="let item of notifyList; let i = index">
              <div class="media">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{ item.by_name}}
                    <!--<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>-->
                  </h3>
                  <p class="text-sm">{{ item.title}}</p>
                  <p class="text-sm text-muted time"><i class="far fa-clock mr-1"></i> {{ timePassed(item.created_at) }}
                  </p>
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </a>
          </div>
          <div *ngIf="eptw_id!='' && eptw_id!=null &&eptw_id!=0">
            <a [routerLink]="['eptw-view', item.eptw_id]" class="dropdown-item"
              *ngFor="let item of notifyList; let i = index">
              <div class="media">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{ item.by_name}}
                    <!--<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>-->
                  </h3>
                  <p class="text-sm">{{ item.title}}</p>
                  <p class="text-sm text-muted time"><i class="far fa-clock mr-1"></i> {{ timePassed(item.created_at) }}
                  </p>
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </a>
          </div>
          <div *ngIf="checklist_id!='' && checklist_id!=null &&checklist_id!=0">
            <a [routerLink]="['checklist-details-view', item.checklist_id]" class="dropdown-item"
              *ngFor="let item of notifyList; let i = index">
              <div class="media">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{ item.by_name}}
                    <!--<span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>-->
                  </h3>
                  <p class="text-sm">{{ item.title}}</p>
                  <p class="text-sm text-muted time"><i class="far fa-clock mr-1"></i> {{ timePassed(item.created_at) }}
                  </p>
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </a>
          </div>
          <!--<a href="#" class="dropdown-item dropdown-footer">See All Messages</a>-->
        </div>
      </li>
      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#" (click)="checkNameChange()">
          <i class="fas fa-user-circle profile-fa-icon"></i>
          <!--<span class="badge badge-warning navbar-badge">15</span>-->
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">Hello {{ userName }}</span>
          <div class="dropdown-divider"></div>
          <span href="#" class="dropdown-item" (click)="openModal()">

            <i class="fas fa-user mr-2"></i> My Profile
          </span>
          <div class="dropdown-divider"></div>
          <span href="#" class="dropdown-item" (click)="logMeOut()">
            <i class="fas fa-sign-out-alt mr-2"></i> Logout
          </span>
          <!-- <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-file mr-2"></i> 3 new reports
            <span class="float-right text-muted text-sm">2 days</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>-->
        </div>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#" role="button">
          <i class="fas fa-th-large"></i>
        </a>
      </li>-->
    </ul>
  </nav>
  <!-- /.navbar -->
  <!-- Main Sidebar Container -->


  <!-- Content Wrapper. Contains page content -->